import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions, ViewStyle} from 'react-native';
import {shadow} from '../lessonList/styles';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return {
    defaultCellStyle: {},
    container: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      backgroundColor: colors.white,
    },
    cellStyle: {
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingTop: 16,
      marginBottom: 12,
      backgroundColor: colors.white,
      ...shadow,
    },

    cellStyleWeb: (index: number) => ({
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 22,
      backgroundColor: index % 2 === 0 ? colors.dirtyWhite : colors.white,
    }),
    cellTextStyleWeb: {
      fontSize: 14,
      lineHeight: 21,
      color: colors.primaryTextColor,
      ...typography.interRegular,
    },

    cellTextStyle: {
      fontSize: 16,
      lineHeight: 19,
      color: colors.primaryTextColor,
      ...typography.interMedium,
    },
    headerTextStyle: {
      fontSize: 14,
      lineHeight: 17,
      color: colors.slateGray,
      ...typography.interMedium,
    },
    flexStart: {
      width: 100,
      marginBottom: Platform.OS !== 'web' ? 12 : 0,
    },
    flexStartForButtons: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      width: 200,
    },
    getRecordingButtonStyle: {
      justifyContent: 'center',
      alignItems: 'center',
      width: 120,
      height: 35,
      backgroundColor: colors.cornflowerBlue,
    },
    getRecordingTextButtonStyle: {
      fontSize: 14,
      lineHeight: 23,
      color: colors.white,
      ...typography.interMedium,
    },
  };
};
